/* ParamPass (embedded in flavor-nav.js)
   持久化并透传白名单参数到站内链接/表单：
   utm_* / gclid / fbclid / discount / coupon / ref / flavor / variant / vp_size / vp_qty 等
*/
(function () {
  const PARAM_WHITELIST = [
    'utm_source','utm_medium','utm_campaign','utm_content','utm_term',
    'gclid','fbclid',
    'discount','coupon','ref',
    'flavor','variant',
    'vp_size','vp_qty','selling_plan','purchase_option'
  ];

  const isInternal = (href) => {
    try { return new URL(href, location.origin).origin === location.origin; }
    catch { return false; }
  };

  const parseQS = (qs) => {
    const out = {};
    new URLSearchParams(qs).forEach((v,k)=>{ out[k]=v; });
    return out;
  };

  const pickWhitelist = (obj) => {
    const out = {};
    PARAM_WHITELIST.forEach(k => {
      if (obj[k] != null && obj[k] !== '') out[k] = String(obj[k]);
    });
    return out;
  };

  const mergeParams = (url, params) => {
    const u = new URL(url, location.origin);
    const sp = new URLSearchParams(u.search);
    Object.entries(params).forEach(([k,v])=>{
      if (v == null || v === '') return;
      if (!sp.has(k)) sp.set(k, v);
    });
    u.search = sp.toString();
    return u.toString();
  };

  const injectHiddenInputs = (form, params) => {
    Object.entries(params).forEach(([k,v])=>{
      if (v == null || v === '') return;
      let input = form.querySelector(`input[type="hidden"][name="${k}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = k;
        form.appendChild(input);
      }
      input.value = v;
    });
  };

  const sourceParams = pickWhitelist(parseQS(location.search));

  const ParamPass = {
    getAll(){ return {...sourceParams}; },
    set(key, val){
      if (!PARAM_WHITELIST.includes(key)) return;
      if (val == null || val === '') delete sourceParams[key];
      else sourceParams[key] = String(val);

      // 同步到页面：更新所有站内链接 & 表单
      this.applyToAll();

      // 同步到地址栏（不刷新）
      const sp = new URLSearchParams(location.search);
      if (val == null || val === '') sp.delete(key); else sp.set(key, val);
      history.replaceState({}, '', `${location.pathname}?${sp.toString()}${location.hash||''}`);
    },
    merge(obj = {}){ Object.entries(obj).forEach(([k,v])=>this.set(k,v)); },
    applyToAll(){
      // 站内链接
      document.querySelectorAll('a[href]').forEach(a=>{
        const href = a.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
        if (!isInternal(href)) return;
        a.setAttribute('href', mergeParams(href, sourceParams));
      });
      // 表单
      document.querySelectorAll('form').forEach(form=>{
        injectHiddenInputs(form, sourceParams);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', ()=> ParamPass.applyToAll());
  window.ParamPass = ParamPass;
})();
